export default "__VITE_ASSET__CBtBlc67__"